import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.logo}>
            <h1>ZR Web Admin</h1>
            <span>Správa sbírky Zoltana Rohala</span>
          </div>
          <div style={styles.userInfo}>
            <span>Přihlášen jako: <strong>{admin?.jmeno}</strong></span>
            <button onClick={handleLogout} style={styles.logoutButton}>
              Odhlásit se
            </button>
          </div>
        </div>
      </header>

      <nav style={styles.nav}>
        <div style={styles.navContent}>
          <Link
            to="/kameny"
            style={{
              ...styles.navLink,
              ...(isActive('/kameny') || location.pathname.startsWith('/kameny') ? styles.activeNavLink : {}),
            }}
          >
            Kameny
          </Link>
          <Link
            to="/sperky"
            style={{
              ...styles.navLink,
              ...(isActive('/sperky') || location.pathname.startsWith('/sperky') ? styles.activeNavLink : {}),
            }}
          >
            Šperky
          </Link>
          <Link
            to="/materialy"
            style={{
              ...styles.navLink,
              ...(isActive('/materialy') || location.pathname.startsWith('/materialy') ? styles.activeNavLink : {}),
            }}
          >
            Materiály
          </Link>
          <Link
            to="/objednavky"
            style={{
              ...styles.navLink,
              ...(isActive('/objednavky') || location.pathname.startsWith('/objednavky') ? styles.activeNavLink : {}),
            }}
          >
            Objednávky
          </Link>
          <Link
            to="/zmena-hesla"
            style={{
              ...styles.navLink,
              ...(isActive('/zmena-hesla') ? styles.activeNavLink : {}),
            }}
          >
            Změna hesla
          </Link>
        </div>
      </nav>

      <main style={styles.main}>
        <div style={styles.content}>
          {children}
        </div>
      </main>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
  },
  header: {
    backgroundColor: '#343a40',
    color: 'white',
    padding: '1rem 0',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    display: 'flex',
    flexDirection: 'column' as const,
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  logoutButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  nav: {
    backgroundColor: '#495057',
    borderBottom: '1px solid #dee2e6',
  },
  navContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
    display: 'flex',
    gap: '0',
  },
  navLink: {
    padding: '1rem 1.5rem',
    color: '#f8f9fa',
    textDecoration: 'none',
    display: 'block',
    transition: 'background-color 0.2s',
    borderBottom: '3px solid transparent',
  },
  activeNavLink: {
    backgroundColor: '#6c757d',
    borderBottom: '3px solid #007bff',
  },
  main: {
    padding: '2rem 0',
    flex: 1,
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
  },
};

export default Layout;
